import React from 'react';
import { WalletIcon, PlusCircleIcon } from 'lucide-react';
interface WalletDisplayProps {
  balance: number;
  onAddFunds?: () => void;
}
export function WalletDisplay({
  balance,
  onAddFunds
}: WalletDisplayProps) {
  return <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-xl p-6 text-white shadow-lg" data-id="element-223">
      <div className="flex items-center justify-between" data-id="element-224">
        <div className="flex items-center space-x-3" data-id="element-225">
          <div className="bg-white/20 p-3 rounded-full" data-id="element-226">
            <WalletIcon className="w-8 h-8" data-id="element-227" />
          </div>
          <div data-id="element-228">
            <p className="text-green-100 text-sm" data-id="element-229">Wallet Balance</p>
            <p className="text-3xl font-bold" data-id="element-230">KES {balance.toLocaleString()}</p>
          </div>
        </div>
        {onAddFunds && <button onClick={onAddFunds} className="flex items-center space-x-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg transition-colors" data-id="element-231">
            <PlusCircleIcon className="w-5 h-5" data-id="element-232" />
            <span className="font-medium" data-id="element-233">Add Funds</span>
          </button>}
      </div>
      <div className="mt-4 pt-4 border-t border-white/20" data-id="element-234">
        <p className="text-sm text-green-100" data-id="element-235">
          💡 News listings are free. Other listings cost 50 KES each.
        </p>
      </div>
    </div>;
}